// Translation: Register > Landing > Form > TOS dialog (Ukrainian)
export default Object.freeze({})
